export const generateAiAssistantText = {
  createTitle: 'Create new AI assistant',
  editTitle: 'Edit AI assistant',
  titlePlaceholder: 'Enter assistant name',
  descriptionPlaceholder: 'Describe your assistant',
  dropdownPlaceholder: 'Select tone',
  searchDropDownPlaceholder: 'Choose where your AI assistant is available',
  assistantCreated: 'AI assistant created',
  assistantEdited: 'AI assistant successfully updated',
  knowledgeBaseTooltip:
    "Select the materials your AI assistant will use to answer learner questions. This can include the lesson's source materials and any supplemental resources you'd like to provide on the lesson topics. Including a variety of relevant content ensures more accurate and helpful responses.",
  knowledgeBaseTitle: 'Knowledge base configuration',
  responseStyleTooltip:
    "A direct response will give straightforward responses to learners' questions with answers from your course materials. An indirect response will ask questions and guide the learners to the answers, but will not provide the answers to them.",
  visibilityTooltip:
    'You can select where learners can access this assistant. If you would like them to access this assistant from within a specific course, please select it here.',
  responseStyle: 'Response style',
  visibility: 'Visibility',
  visibilityPlaceholder: 'Choose where your AI assistant is available',
  communicationTone: 'Communication tone',
};
